import { create } from "zustand";
import { DateRange } from "@/constants/date-range";
import { FilterDate, ONE_DAY_IN_MS, ONE_MONTH_IN_MS, ONE_WEEK_IN_MS } from "@/constants/filters";

interface State {
  date: DateRange;
  setDate: (date: DateRange) => void;
  setValue: (value: FilterDate) => void;
  value: FilterDate;
  lastUpdatedDate: Date;
  setLastUpdatedDate: (date: Date) => void;
}

export const useDateStore = create<State>((set) => {
  const now = new Date();
  // Default 'date' calculation changed to 30 days
  const thirtyDaysAgo = new Date(now.getTime() - ONE_MONTH_IN_MS);

  return {
    date: {
      from: thirtyDaysAgo,
      to: now,
    },
    setDate: (date: DateRange) => set({ date }),
    setValue: (value?: FilterDate) => set({ value }),
    value: FilterDate.D30, // Default filter type changed to 30D
    lastUpdatedDate: now,
    setLastUpdatedDate: (date: Date) => set({ lastUpdatedDate: date }),
  };
});

export function calculateDate(filterDate: FilterDate) {
  const now = new Date()
  switch (filterDate) {
    case FilterDate.H24:
      return { from: new Date(now.getTime() - ONE_DAY_IN_MS), to: now }
    case FilterDate.D7:
      return { from: new Date(now.getTime() - ONE_WEEK_IN_MS), to: now }
    case FilterDate.D30:
      return { from: new Date(now.getTime() - ONE_MONTH_IN_MS), to: now }
    default:
      throw new Error(`Invalid value: ${filterDate}`)
  }
}